export const FETCH_WHITELIST = 'WHITELIST/FETCH_REQUEST';
export const FETCH_WHITELIST_SUCCESS = 'WHITELIST/FETCH_SUCCESS';
export const FETCH_WHITELIST_FAILURE = 'WHITELIST/FETCH_FAILURE';

export const CREATE_WHITELIST = 'WHITELIST/POST_REQUEST';
export const CREATE_WHITELIST_SUCCESS = 'WHITELIST/POST_SUCCESS';
export const CREATE_WHITELIST_FAILURE = 'WHITELIST/POST_FAILURE';

export const UPDATE_WHITELIST = 'WHITELIST/PUT_REQUEST';
export const UPDATE_WHITELIST_SUCCESS = 'WHITELIST/PUT_SUCCESS';
export const UPDATE_WHITELIST_FAILURE = 'WHITELIST/PUT_FAILURE';

export const DELETE_WHITELIST = 'WHITELIST/DELETE_REQUEST';
export const DELETE_WHITELIST_SUCCESS = 'WHITELIST/DELETE_SUCCESS';
export const DELETE_WHITELIST_FAILURE = 'WHITELIST/DELETE_FAILURE';

export const SET_FILTER = 'WHITELIST/DASHBOARD/FILTERS/SET_ONE';
export const CLEAR_FILTERS = 'WHITELIST/DASHBOARD/FILTERS/CLEAR';

export const CHECK_PLATE_EXIST = 'WHITELIST/HEAD_EXIST_REQUEST';

export const OPEN_MODAL = 'WHITELIST/MODAL/OPEN';
export const CLOSE_MODAL = 'WHITELIST/MODAL/CLOSE';
